import {nodeListToArray} from "./nodeListToArray";
import {yieldToMainBackground} from "./yield";

export function setupTabs() {
    function getLocalStorageKey(tabGroupLabel) {
        return 'Tab Group/' + tabGroupLabel;
    }

    function initTabContainer(tabContainer) {
        function setTab(activeIndex) {
            const tabListItems = nodeListToArray(tabContainer.querySelector('.tabs').querySelectorAll('li'));
            const tabsAll = nodeListToArray(tabContainer.querySelectorAll('.tab'));

            const tabs = tabsAll.filter(tab => tab.parentNode === tabContainer);

            tabListItems.forEach((tabListItem, index) => {
                const isActive = index === activeIndex;
                const tabControl = tabListItem.querySelector('[role="tab"], a, button');

                tabListItem.classList.toggle('is-active', isActive);
                if (tabControl) {
                    tabControl.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    tabControl.tabIndex = isActive ? 0 : -1;
                }
                if (tabs[index]) {
                    tabs[index].classList.toggle('is-hidden', !isActive);
                    tabs[index].hidden = !isActive;
                }
            });
        }

        const tabGroupLabel = tabContainer.getAttribute('data-tab-group');
        const localStorageKey = getLocalStorageKey(tabGroupLabel);

        tabContainer.setAttribute("data-tabsetup", 'yes'); // Only setup once

        const tabListItems = nodeListToArray(tabContainer.querySelector('.tabs').querySelectorAll('li'));
        const tabLabels = [];
        let defaultActiveIndex = 0;

        function activateTab(activeIndex, moveFocus) {
            const activeTabControl = tabListItems[activeIndex].querySelector('[role="tab"], a, button');
            const activeTabLabel = tabLabels[activeIndex];

            setTab(activeIndex);
            if (moveFocus) {
                activeTabControl.focus();
            }

            yieldToMainBackground().then(() => {
                try {
                    localStorage.setItem(localStorageKey, activeTabLabel);
                } catch (e) {
                    // Expected condition so not reporting, sometimes local storage is off
                    console.warn('Could not store tab state: ' + localStorageKey);
                }

                if (typeof gtag === 'function') {
                    gtag('event', 'tab-action', {
                        'event_category': 'switch-tab',
                        'event_label': tabGroupLabel + '/' + activeTabLabel
                    });
                }
            });
        }

        tabListItems.forEach((tabListItem, tabListIndex) => {
            const tabLabel = tabListItem.getAttribute('data-tab');
            tabLabels.push(tabLabel);

            if (tabListItem.classList.contains('is-active')) {
                defaultActiveIndex = tabListIndex;
            }

            const tabControl = tabListItem.querySelector('[role="tab"], a, button');

            tabControl.addEventListener('click', function (event) {
                event.preventDefault();
                activateTab(tabListIndex, false);
            });
            tabControl.addEventListener('keydown', function (event) {
                let nextIndex = null;

                if (event.key === 'ArrowRight') {
                    nextIndex = (tabListIndex + 1) % tabListItems.length;
                } else if (event.key === 'ArrowLeft') {
                    nextIndex = (tabListIndex - 1 + tabListItems.length) % tabListItems.length;
                } else if (event.key === 'Home') {
                    nextIndex = 0;
                } else if (event.key === 'End') {
                    nextIndex = tabListItems.length - 1;
                } else if (event.key === 'Enter' || event.key === ' ') {
                    nextIndex = tabListIndex;
                }

                if (nextIndex !== null) {
                    event.preventDefault();
                    activateTab(nextIndex, true);
                }
            });
        });

        try {
            const activeTabLabel = localStorage.getItem(localStorageKey);
            if (activeTabLabel !== null) {
                let localStorageActiveIndex = tabLabels.indexOf(activeTabLabel);
                if (localStorageActiveIndex !== -1 && localStorageActiveIndex !== defaultActiveIndex) {
                    setTab(localStorageActiveIndex);
                }
            }
        } catch (e) {
            // Expected condition so not reporting, sometimes local storage is off
            console.warn('Could not get tab state: ' + localStorageKey);
        }
    }

    const tabContainers = nodeListToArray(document.querySelectorAll('.tabs-container:not([data-tabsetup="yes"])'));
    tabContainers.forEach(initTabContainer);
}
